<template>
  <div class="container">
	<b-row>
		<b-col md="12" class="p-0">
			<div>
				<h5 class="section-title">{{params.trans['stock_market']}}</h5>
				<Slider v-bind:items="params['stock_market']['slider_items']" v-bind:settings="slider_settings" v-bind:page="'investors'"></Slider>
			</div>
		</b-col>
  	</b-row>
  </div>
</template>
<script>
import Slider from '@/components/Slider.vue'

export default {
	name: 'investors_info',
	components: {
		Slider
	},
	props: ['params'],
	data() {
		return {
			slider_settings: {
				main_class: 'report',
				mouseDrag: false,
				shortDrag: false, // so it won't slide on mobile screen just by touching it
				transition: 600,
				wheelControl: false,
				initialSlide: 0,
				infiniteScroll: true,
				centerMode: false,
				itemsToSlide: 1,
				breakpoints: {
		            0: {
		              itemsToShow: 3,
		              // centerMode: false,
		              // pagination: 'indicator'
		            },
					767.98: {
					  itemsToShow: 6,
					},
		            991.98: {
					  itemsToShow: 7
		              // pagination: 'fraction'
		            },
					1200: {
					  itemsToShow: 7
					}
	          	}
	        }
		}
	}
	/*created() {
		console.log(this.params);
	}*/
}
</script>
<style scoped>
.static-slider-wrapper .border-slide {
	height: 140px;
	width: 26.2%;
}
.static-slider-wrapper a {
	color: inherit;
}
.static-slider-wrapper .border-slide {
	border: 2px solid rgb(0, 38, 61);
}
.static-slider-wrapper .border-slide hr {
	background-color: #00263d;
	border-top: none;
	height: 3px;
}
.static-slider-wrapper .border-slide .year-label {
	left: 0;
	bottom: 1px;
}
.static-slider-wrapper .border-slide .up p {
	line-height: 18px;
	font-size: 12px;
}
.static-slider-wrapper .border-slide .down p {
	font-size: 9px;
	top: -4px;
}
.static-slider-wrapper .border-slide .inner-slide {
	/*transition: background-color 0.25s ease-in-out;*/
}
.static-slider-wrapper .border-slide .inner-slide.up {
	background-color: rgba(255, 255, 255, 0.7);
}
.static-slider-wrapper .border-slide .inner-slide.down {
	background-color: rgba(0, 38, 61, 0.7);
}
.static-slider-wrapper .border-slide .investors-selected .inner-slide.up {
	background-color: rgba(255, 255, 255, 1);
}
.static-slider-wrapper .border-slide .investors-selected .inner-slide.down {
	background-color: rgba(0, 38, 61, 1);
}


.ani_icon {
    display: inline-block;
    position: relative;
	width: 100%;
    height: 25px;
    overflow: hidden;
    cursor: pointer;
}
.slide-1 {
    position: absolute;
    top:-3px; left:0;
    height: 100%;
    width: 100%;
    transition: all .5s;
}
img {
	width: 19px;
}
.static-slider-wrapper .border-slide:hover .ani_icon.slider-down .slide-1 { top: 100%; opacity:0; }

.slide-2 {
    position: absolute;
    height: 100%;
    width: 100%;
    font-size: 1.2em;
    transition: all .5s;
    opacity: 0;
}

.ani_icon.slider-down .slide-2 { top: -100%; }


.static-slider-wrapper .border-slide:hover .ani_icon.slider-down .slide-2 { top:-3px; opacity: 1; }


@media screen and (max-width:1200px) {
	.static-slider-wrapper .border-slide {
		
	}
}
@media screen and (max-width:991.98px) {
	.static-slider-wrapper .border-slide {
		width: 32.5%
	}
}
@media screen and (max-width:767.98px) {
	.static-slider-wrapper .border-slide {
		
	}
}

</style>